<div class="auth-container">
  <div class="auth-sub-container" style="max-width: 350px !important;">

    <img src="logo.png" alt="Wide & Heavy" class="logo" matTooltip="Wide & Heavy"/>

    <h1 class="title">Password reset</h1>

    <mat-stepper linear #stepper class="auth-stepper">

      <!-- STEP 1 -->
      <mat-step [stepControl]="emailForm" [editable]="false">
        <ng-template matStepLabel>Enter</ng-template>

        <form [formGroup]="emailForm" (ngSubmit)="checkUserAndSendToken(stepper)">
          <mat-form-field appearance="outline" class="auth-form-field mt-10">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="email" placeholder="Enter your email" [readonly]="loading()"
              required autocomplete="username" />
            @if (emailForm.get('email')?.hasError('required')) {
            <mat-error>Email is required</mat-error>
            }
            @if (emailForm.get('email')?.hasError('email')) {
            <mat-error>Invalid email</mat-error>
            }
          </mat-form-field>

          <button mat-flat-button class="main-button-squared-full-width lightyellow mb-25" type="submit"
            [disabled]="emailForm.invalid || loading()">
            @if(!loading()) { <span>Continue</span> }
            @else { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> }
          </button>
        </form>
      </mat-step>

      <!-- STEP 2 -->
      <mat-step [stepControl]="verifyTokenForm" [editable]="false">
        <ng-template matStepLabel>Verify</ng-template>

        <form [formGroup]="verifyTokenForm" (ngSubmit)="verifyTokenAndContinue(stepper)">
          <mat-form-field appearance="outline" class="auth-form-field mt-10">
            <mat-label>Verification code</mat-label>
            <input matInput formControlName="code" placeholder="Enter verification code" required autocomplete="one-time-code"/>
          </mat-form-field>

          <button mat-flat-button class="main-button-squared-full-width lightyellow mb-25" type="submit"
            [disabled]="verifyTokenForm.invalid || loading()">
            @if(!loading()) { <span>Continue</span> }
            @else { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> }
          </button>


          <div class="yellow-container mt-10" style="padding: 0;">
            @if(resendEmailCodeTimer() > 0) {
            <div class="timer-container">
              Didn't get a code? Resend it in {{ resendEmailCodeTimer() }}
            </div>
            } @else {
            <div class="timer-container">
              Didn't get a code?
              <a (click)="createToken()">Resend it</a>
            </div>
            }
          </div>

        </form>
      </mat-step>

      <!-- STEP 3 -->
      <mat-step [stepControl]="resetPasswordForm" [editable]="false">
        <ng-template matStepLabel>Reset</ng-template>

        <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPasswordAndFinish()">
          <mat-form-field appearance="outline" class="auth-form-field mt-10">
            <mat-label>New password</mat-label>
            <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" required autocomplete="new-password" />
            <button mat-button matSuffix type="button" (click)="hidePassword = !hidePassword">
              {{ hidePassword ? 'Show' : 'Hide' }}
            </button>
          </mat-form-field>

          <button mat-flat-button class="main-button-squared-full-width lightyellow mb-25" type="submit"
            [disabled]="resetPasswordForm.invalid || loading()">
            @if(!loading()) { <span>Reset</span> }
            @else { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> }
          </button>
        </form>
      </mat-step>

    </mat-stepper>

    <div class="bottom-actions">
      <button mat-button class="danger-button" (click)="goToLogin()">
        Cancel
      </button>
    </div>

  </div>
</div>